/***
 * Created on 2024/1/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {useOrganization} from "../context/OrganizationContext";
import EmailChangedDialog from "../component/main-content/EmailChangedDialog";


function useEmailChangedHook(props) {

    const WarningDialog = ({}) => {
        const {userProfile, getCurrentOrg, setCurrentOrg} = useOrganization();
        const org = getCurrentOrg();
        const [emailChanged, setEmailChanged] = useState(org?.users?.filter(user => user?.email_changed));
        const [showChangeDialog, setShowChangeDialog] = useState(false);

        const updateUserEmail = (updated_users) => {
            updated_users.forEach((user) => {
                if (user.action === 'accept') {
                    delete org.users?.find(ou => user.id === ou.id)?.email_changed;
                }
                else if (user.action === 'reject') {
                    org.users = org.users?.filter(ou => user.id !== ou.id);
                }
            });
            setCurrentOrg(org);
        }

        useEffect(() => {
            if (emailChanged?.length > 0) {
                setShowChangeDialog(true);
            }
        }, [emailChanged?.length]);

        return (
            <>
                {showChangeDialog && <EmailChangedDialog isOpenDialog={showChangeDialog} onClose={()=>setShowChangeDialog(false)} org={org} emailChangedUsers={emailChanged} doRefresh={updateUserEmail} hideCancel={true}/>}
            </>
        )
    }

    return {EmailWarningDialog: WarningDialog};
}

export default useEmailChangedHook;